import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  SAVE_SUGGESTEDPF,
  SAVE_SUGGESTEDPF_ERROR,
  SAVE_SUGGESTEDPF_SUCCESS,

  GET_SUGGESTEDPF_BY_DATE,
  GET_SUGGESTEDPF_BY_DATE_ERROR,
  GET_SUGGESTEDPF_BY_DATE_SUCCESS,

  DELETE_SUGGESTEDPF,
  DELETE_SUGGESTEDPF_ERROR,
  DELETE_SUGGESTEDPF_SUCCESS,

  GET_TRANSACTION_PF,
  GET_TRANSACTION_PF_SUCCESS,
  GET_TRANSACTION_PF_ERROR,

  GET_SUGGESTED_PF,
  GET_SUGGESTED_PF_ERROR,
  GET_SUGGESTED_PF_SUCCESS,
} from './constants';

export default {
  async [DELETE_SUGGESTEDPF]({ commit }, data) {
    try {
      commit(DELETE_SUGGESTEDPF);
      const response = await axios({
        url: `${process.env.API_URL}/api/suggested-provident-fund/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_SUGGESTEDPF_SUCCESS, response.data);
    } catch (err) {
      commit(DELETE_SUGGESTEDPF_ERROR, err);
    }
  },
  async [GET_SUGGESTEDPF_BY_DATE]({ commit }, data) {
    try {
      commit(GET_SUGGESTEDPF_BY_DATE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/suggested-provident-fund/${data.date}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_SUGGESTEDPF_BY_DATE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_SUGGESTEDPF_BY_DATE_ERROR, err);
    }
  },
  async [SAVE_SUGGESTEDPF]({ commit }, data) {
    try {
      commit(SAVE_SUGGESTEDPF);
      let url = `${process.env.API_URL}/api/suggested-provident-fund`;
      let method = 'POST';
      if (data.suggestedProvidentFundID) {
        url = `${url}/${data.suggestedProvidentFundID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_SUGGESTEDPF_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_SUGGESTEDPF_ERROR, err);
    }
  },

  async [GET_TRANSACTION_PF]({ commit }, data) {
    try {
      commit(GET_TRANSACTION_PF);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/provident-fund`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_TRANSACTION_PF_SUCCESS, response.data);
    } catch (err) {
      commit(GET_TRANSACTION_PF_ERROR, err);
    }
  },

  async [GET_SUGGESTED_PF]({ commit }, data) {
    try {
      commit(GET_SUGGESTED_PF);
      const listParam = data.list ? `?list=${data.list}` : '';
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/suggested-provident-funds/data${listParam}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_SUGGESTED_PF_SUCCESS, response.data);
    } catch (err) {
      commit(GET_SUGGESTED_PF_ERROR, err);
    }
  },

};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/SuggestedPF/actions.js